/**
 * Input — champ de saisie stylisé avec label optionnel.
 */
import { useState } from "react";
import { colors, fonts } from "../styles/tokens";

export default function Input({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  error,
  required = false,
  icon,
  fullWidth = true,
  style = {},
  ...rest
}) {
  const [focused, setFocused] = useState(false);

  const wrapperStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: fullWidth ? "100%" : "auto",
    fontFamily: fonts.body,
  };

  const inputWrapperStyle = {
    display: "flex",
    alignItems: "center",
    background: colors.bg,
    border: `1px solid ${error ? colors.danger : focused ? colors.gold : colors.border}`,
    borderRadius: "10px",
    transition: "all 150ms",
    boxShadow: focused ? "0 0 0 3px rgba(228,167,44,0.15)" : "none",
    overflow: "hidden",
  };

  const inputStyle = {
    flex: 1,
    background: "transparent",
    color: colors.text,
    border: "none",
    outline: "none",
    fontSize: "14px",
    padding: "12px 14px",
    fontFamily: fonts.body,
    ...style,
  };

  return (
    <label style={wrapperStyle}>
      {label && (
        <span style={{ fontSize: "13px", fontWeight: 500, color: colors.muted }}>
          {label} {required && <span style={{ color: colors.gold }}>*</span>}
        </span>
      )}
      <div style={inputWrapperStyle}>
        {icon && (
          <span style={{ paddingLeft: "12px", color: colors.muted, fontSize: "16px" }}>
            {icon}
          </span>
        )}
        <input
          type={type}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          style={inputStyle}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          {...rest}
        />
      </div>
      {error && (
        <span style={{ fontSize: "12px", color: colors.danger }}>{error}</span>
      )}
    </label>
  );
}
